import { OrgLevel, AnsweredQuestionWithId } from "../questionnaires/model";
import { QuestionnaireConfig, MasterQuestionConfig } from "../questionnaires/questionnaireConfig/models";

export const PHYSIOTHERAPY_MGR_REFERRAL_QUESTIONNAIRE_KEY = "PhysiotherapyMgrReferralForm";
export const PHYSIOTHERAPY_SELF_REFERRAL_QUESTIONNAIRE_KEY = "PhysiotherapySelfReferralForm";

export const lineManagerHrSectionId = "LineManagerHR";
export const employeeDetailSectionId = "ReferredDetails";
export const reasonsForReferralSectionId = "ReasonsForReferral";
export const attachmentsSectionId = "Attachments";
export const orgLevelQuestionId = "OrgLevel";
export const furtherDetailsSectionId = "FurtherDetails";
export const furtherDetailsSectionTitle = "Further Details";

export interface PhysiotherapyReferralFormProps {
    readonly: boolean;
    questionnaireConfig: QuestionnaireConfig;
    api?: string;
    afterSubmit?: (ohCaseId: string) => void;
    loadOrgStructure?: (parentOrgStructureLevelId: string) => void;
    linkedOhCaseId?: string;
    documentBaseApi: string;
}

export enum PhysiotherapyReferralType {
    Unknown = 0,
    MGR = 1,
    Self = 2
}

export const CURRENT_WORK_STATUS = [
    "At work no restrictions on duties",
    "At work restrictions in place",
    "Not at work"
].map(s => ({ text: s, value: s }));

export const BODY_PARTS = [
    { value: "Ankle", text: "Ankle" },
    { value: "Back", text: "Back", old: true },
    { value: "Elbow", text: "Elbow" },
    { value: "Face", text: "Face" },
    { value: "Foot", text: "Foot" },
    { value: "Hand", text: "Hand" },
    { value: "Head", text: "Head" },
    { value: "Hip", text: "Hip" },
    { value: "Knee", text: "Knee" },
    { value: "LowerBack", text: "Low Back" },
    { value: "LowerLimb", text: "Lower Limb" },
    { value: "Multiple", text: "Multiple" },
    { value: "Neck", text: "Neck" },
    { value: "Pelvis", text: "Pelvis" },
    { value: "Shoulders", text: "Shoulder" },
    { value: "UpperArm", text: "Upper arm", old: true },
    { value: "UpperBack", text: "Upper Back" },
    { value: "UpperLimb", text: "Upper Limb" },
    { value: "WholeBody", text: "Whole Body" },
    { value: "Wrist", text: "Wrist" }
];

export interface PhysiotherapyMgrReferralFormState {
    orgLevels: OrgLevel[];
}

export type PhysiotherapyAssessmentConsultationType = "Face2Face" | "Telephone" | "Review" | "Unknown";

export enum PhysiotherapyAssessmentConsultationMode {
    Face2Face = "Face2Face",
    Telephone = "Telephone",
    Review = "Review",
    Unknown = "Unknown"
}

export type PhysiotherapyAssessmentConsultationQuestionConfig = MasterQuestionConfig & {
    consultationModes: PhysiotherapyAssessmentConsultationType[];
};

export interface PhysiotherapyReferralCaseCreateModel {
    formData: {
        questions: AnsweredQuestionWithId[];
    };
    linkedOhCaseId?: string;
}
